import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import socket from "../../../assets/socket";
import { Helmet } from "react-helmet-async";
const base_url = process.env.REACT_APP_API_URL;

const minBetAmount = 10;
const maxBetAmount = 10000;

const SpinWheel = () => {
  const token = localStorage.getItem("token");
  const [walletBalance, setWalletBalance] = useState(0);
  const [userId, setUserId] = useState(null);
  const [gameId, setGameId] = useState(null);
  const [betAmount, setBetAmount] = useState(minBetAmount);
  const [zeroBetCount, setZeroBetCount] = useState(0);
  const [oneBetCount, setOneBetCount] = useState(0);
  const [twoBetCount, setTwoBetCount] = useState(0);
  const [threeBetCount, setThreeBetCount] = useState(0);
  const [fourBetCount, setFourBetCount] = useState(0);
  const [fiveBetCount, setFiveBetCount] = useState(0);
  const [sixBetCount, setSixBetCount] = useState(0);
  const [sevenBetCount, setSevenBetCount] = useState(0);
  const [eightBetCount, setEightBetCount] = useState(0);
  const [nineBetCount, setNineBetCount] = useState(0);
  const [oddBetCount, setOddBetCount] = useState(0);
  const [evenBetCount, setEvenBetCount] = useState(0);
  const [totalBetQty, setTotalBetQty] = useState(0);
  const [isBetModalOpen, setIsBetModalOpen] = useState(false);
  const [isBetHistoryModalOpen, setIsBetHistoryModalOpen] = useState(false);
  const [isResultModalOpen, setIsResultModalOpen] = useState(false);
  const [timmer, setTimmer] = useState(30);
  const [resultDetails, setResultDetails] = useState([
    5, 8, 4, 1, 2, 3, 2, 8, 9, 1,
  ]);
  const [result, setResult] = useState();
  const [rotation, setRotation] = useState(0);
  const [selectedBoxesAndQty, setSelectedBoxesAndQty] = useState([]);
  const [userBetHistory, setUserBetHistory] = useState([]);
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [spinnerRolling, setSpinnerRolling] = useState(false);
  const [lastBetAmount, setLastBetAmount] = useState(0);
  const [lastWinAmount, setLastWinAmount] = useState(0);

  const audioFiles = {
    bet: new Audio("/spinwheel/audio/bet.mp3"),
    spin: new Audio("/spinwheel/audio/spin.mp3"),
    click: new Audio("/spinwheel/audio/click.mp3"),
  };

  useEffect(() => {
    Object.values(audioFiles).forEach((audio) => {
      audio.preload = "auto";
      audio.load();
      audio.onerror = () => console.error(`Failed to load audio: ${audio.src}`);
    });
  }, []);

  function playSound(audio) {
    if (soundEnabled) {
      try {
        audio.currentTime = 0;
        audio
          .play()
          .catch((error) =>
            console.error(`Error playing ${audio.src}:`, error),
          );
      } catch (error) {
        console.error(`Error playing ${audio.src}:`, error);
      }
    }
  }

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(
        `${base_url}/api/get_user_detail_spin_wheel`,
        {
          method: "GET",
          headers: {
            Authorization: token,
          },
        },
      );

      if (response.status >= 300 && response.status < 400) {
        toast.error("Please log in to continue.");
        window.location.href = "/login";
        return;
      }

      if (!response.ok)
        throw new Error(
          `Network response was not ok: ${response.status} ${response.statusText}`,
        );

      const result = await response.json();

      if (result.isSuccess && result.data) {
        const money = parseFloat(result.data.money);
        setWalletBalance(isNaN(money) ? 0 : Math.floor(money));
        setUserId(result.data.username || null);
        setGameId(result.data.currentGameId || null);
        setTimmer(result.data.timmer);
        setResultDetails(result.data.game_result);
        setUserBetHistory(result.userBetResult);
        setLastBetAmount(result.totalBetAmount);
        setLastWinAmount(result.totalWinAmount);

        // if (result.isUserBet > 0) {
        //   setSpinnerRolling(true);
        // }

        if (result.totalBetAmount || result.totalWinAmount) {
          if (result.data.timmer > 23) {
            setIsResultModalOpen(true);

            setTimeout(() => {
              setIsResultModalOpen(false);
            }, 4000);
          }
        }
      } else {
        console.error("Failed to fetch user details.");
      }
    } catch (error) {
      console.error("Fetch user details error:", error);
    }
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);

  // socket start
  useEffect(() => {
    const handleSocketData = async (payload) => {
      const gotResult = payload.data.result;
      console.log(gotResult, "result");

      setResult(gotResult);
      setGameId(payload.data.period);
      setTimmer(0);
      setSpinnerRolling(true);
      setTimeout(() => {
        setSpinnerRolling(false);
        fetchUserDetails();
      }, 6000);
    };

    const handleConnect = () => {
      console.log("✅ Admin Connected to Real-time Updates");
    };

    socket.on("connect", handleConnect);
    socket.on("spin_wheel_update", handleSocketData);
    socket.on("bet_by_spin_wheel", (payload) => {
      handleSocketData(payload);
    });

    return () => {
      socket.off("connect", handleConnect);
      socket.off("spin_wheel_update", handleSocketData);
    };
  }, []);
  // socket end

  useEffect(() => {
    const interval = setInterval(() => {
      setTimmer((prev) => {
        if (prev === 0) {
          // Determine the target number: use result if between 0-9, otherwise random
          const targetNumber =
            result >= 0 && result <= 9
              ? result
              : Math.floor(Math.random() * 10);
          const randomRotations = Math.floor(Math.random() * 5 + 6) * 360; // 5-9 full rotations
          const angleMap = {
            0: 9,
            1: 1.11,
            2: 1.11,
            3: 1.11,
            4: 6.7,
            5: 10,
            6: 4.29,
            7: 5.39,
            8: 6.67,
            9: 8.2,
          };

          const anglePerDefined = angleMap[result] ?? 0;
          const anglePerNumber = 360 / anglePerDefined; // 36 degrees per number
          const finalAngle = randomRotations + targetNumber * anglePerNumber;
          playSound(audioFiles.spin);
          setRotation(rotation * 2);
          setTimeout(() => {
            setRotation(0);
            setRotation(finalAngle);
          }, 500);

          return 30;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [result]);

  function updateBet(key, setCount) {
    playSound(audioFiles.click);
    setTotalBetQty(totalBetQty + 1);
    setCount((prevCount) => {
      const newCount = prevCount + 1;

      setSelectedBoxesAndQty((prev) => {
        // ensure we always have one object in array
        const updated = prev.length > 0 ? { ...prev[0] } : {};

        // store as string instead of number
        updated[key] = String(newCount);

        return [updated]; // wrap back into array
      });

      return newCount;
    });
  }

  function zeroNumberBet() {
    updateBet("0", setZeroBetCount);
  }

  function oneNumberBet() {
    updateBet("1", setOneBetCount);
  }

  function twoNumberBet() {
    updateBet("2", setTwoBetCount);
  }

  function threeNumberBet() {
    updateBet("3", setThreeBetCount);
  }

  function fourNumberBet() {
    updateBet("4", setFourBetCount);
  }

  function fiveNumberBet() {
    updateBet("5", setFiveBetCount);
  }

  function sixNumberBet() {
    updateBet("6", setSixBetCount);
  }

  function sevenNumberBet() {
    updateBet("7", setSevenBetCount);
  }

  function eightNumberBet() {
    updateBet("8", setEightBetCount);
  }

  function nineNumberBet() {
    updateBet("9", setNineBetCount);
  }

  function oddBet() {
    updateBet("odd", setOddBetCount);
  }

  function evenBet() {
    updateBet("even", setEvenBetCount);
  }

  function clearAllBets() {
    playSound(audioFiles.click);
    setZeroBetCount(0);
    setOneBetCount(0);
    setTwoBetCount(0);
    setThreeBetCount(0);
    setFourBetCount(0);
    setFiveBetCount(0);
    setSixBetCount(0);
    setSevenBetCount(0);
    setEightBetCount(0);
    setNineBetCount(0);
    setOddBetCount(0);
    setEvenBetCount(0);
    setTotalBetQty(0);
  }

  function minusBet() {
    playSound(audioFiles.click);
    const newBetAmount = betAmount - 1;
    setBetAmount(newBetAmount < minBetAmount ? minBetAmount : newBetAmount);
  }

  function plusBet() {
    playSound(audioFiles.click);
    const newBetAmount = betAmount + 1;
    setBetAmount(newBetAmount > maxBetAmount ? maxBetAmount : newBetAmount);
  }

  function betOptions() {
    playSound(audioFiles.click);
    setIsBetModalOpen((prev) => !prev);
  }

  function betHistoryBtn() {
    playSound(audioFiles.click);
    setIsBetHistoryModalOpen((prev) => !prev);
  }

  function betResultBtn() {
    playSound(audioFiles.click);
    setIsResultModalOpen((prev) => !prev);
  }

  const handleBetChange = (e) => {
    const value = e.target.value;
    if (value === "") {
      setBetAmount("");
      return;
    }
    const numValue = Number(value);
    if (
      !isNaN(numValue) &&
      numValue >= minBetAmount &&
      numValue <= maxBetAmount
    ) {
      setBetAmount(numValue);
    } else if (numValue < minBetAmount) {
      setBetAmount(minBetAmount);
    } else if (numValue > maxBetAmount) {
      setBetAmount(maxBetAmount);
    }
  };

  const betPlace = async () => {
    if (!userId) {
      toast.error("Please Login First!");
      return;
    }

    if (selectedBoxesAndQty.length < 1) {
      toast.error("Select at least 1 to bet placed!");
      return;
    }

    if (betAmount > walletBalance) {
      toast.error("Insufficient balance to place the bet.");
      return;
    }

    try {
      const response = await fetch(`${base_url}/api/spin_wheel_bet`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          betAmount,
          totalBetQty,
          gameId,
          userId,
          selectedBoxesAndQty,
        }),
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const result = await response.json();

      if (result.success === true) {
        setSelectedBoxesAndQty([]);
        clearAllBets();
        setSpinnerRolling(false);
        playSound(audioFiles.bet);
        const money =
          parseFloat(result.data.money) || walletBalance - betAmount;
        setWalletBalance(Math.floor(money));
        toast.success(result.message);
        fetchUserDetails();
      } else {
        toast.error(result.message || "Failed to place bet.");
      }
    } catch (error) {
      toast.error(`Error placing bet: ${error.message}`);
      console.error("Bet placement error:", error);
    }
  };

  function betNow() {
    betPlace();
  }

  return (
    <>
      <Helmet>
        <title>
          Spin Wheel Game – Play & Earn | 10% Welcome Bonus | Henwin
        </title>
        <meta
          name="description"
          content="Try the Spin Wheel and get a 10% bonus on your first recharge. Play easy, win fast, and enjoy bonus rewards on Henwin."
        />
        <meta
          name="keywords"
          content="10% bonus, first recharge bonus, welcome bonus spin wheel, bonus spin game"
        />
      </Helmet>

      <link rel="stylesheet" href="/spinwheel/css/spin-wheel-style.css" />
      <div id="root">
        <div className="Toastify" />
        <div className="flex h-screen font-inter">
          <div className="flex-1 bg-[#9195A3]" />
          <div className="bg-bg1 shrink-0 bg-red flex flex-col h-screen overflow-hidden w-full xsm:w-[400px] text-white">
            <div className="h-[3.22rem] w-full xsm:w-[400px] z-50 fixed top-0 hidden">
              <div className="font-inter">
                <div className="bg-red px-3 pt-2 h-[3.22rem] pb-2 flex justify-between items-center">
                  <a href="/">
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMZSURBVHgBxVqBldowDBW3QNmg3qCM4BHY4Nig3YDcBEcngA3KBukGuU6Q6wThJtDJLzIoxkAcy7n/nl4ewZa+ZDmWnSxAAYi4pMua5AeJIVmRLFk83lneSP6R/F0sFu/wVXCkSbYkNU5HQ7IhMTARC0gER/snyS8YRtjhBJcof/Bv4Hbf+bqK9HM4kLwUHRWOeBeJYkViE/RY7tNGRmUL2nBDzEQl6hTSd3Q7Zw6B7jYnrUIDz0HUGw3iETsrHI6Is7mGHHDKSOygMDi18lMqIN+ViPod22scjnqaE6xAPx/TOBgcptRzSsdORN6AMrBfQ8yIdulcAq/zJlFc/0qQsiPaW8GnedR4KxpXoIyA/OgAUbvdQ148XOe8B2VEyFeJ/RuRSstYg71QvgJF5JJnHfZm/yD6e1CEBnmhq46OAvYVoYcFJXDUVMgLfde6RH6p5T72JQhqkRd6Pdfa3zAFjBQhz7plqbFUT5+S5Fm/TKONfMZ2kInS5IUdP692cmbXkIG5yLMtPw+OsnQ4wkTMSZ7tHdhOC8LopFp/bvJs85z2T+L+CRKB/WJyELfcpryC8jgfFjxBHsKaZHIaToVzQB59JIGPQF7ErRqV66gbGJQRLefT5BoIh4tLV9oJ0v9HTmL/o8lUOpsTKB/9qLuQhU6o7+jYzmAh0y4lpBMO4zbj4/VflRJLVH6Gl3Qi0G38zVpjHtwxpOYEXh46zS1jFpSg7cRV+og/XBr5iZFV1EWMqjmBw327uWfIgiI0nMB+b+2xjzWQo6A2F4T+LCdweOBmxhh5BWVEnLAj+21Fn+pR4ybVQAoCJx4udBgcNMOIDgbLH+46UpsR7aZxweHq3JZwYgQHgzkHzThTXXPDtkWNAzHUet2TZvM1sFlBDvD6dU+LBUpljnoTjPoGNBDJR4c96r1mrQPdTZF5F0kpPyIVpr/o3uL1u+cuNWWmfGpg6FKRxFZSt79+g8snBx98/xtcPjMwEP9E4TfJjvbZyacjk8BptYlEMQU1j17ygYJH8gjccoYuFvoI+09ujGhygsvo/OfrUSPan6uQr+opoFVSAAAAAElFTkSuQmCC"
                      alt="drf"
                      className="w-6 h-6"
                    />
                  </a>
                  <img
                    className="w-12 h-12 rounded-full"
                    src="/spinwheel/images/usawinlogo-CPLlmxqC.png"
                    alt="logo not found"
                  />
                  <div className="flex items-center gap-2">
                    <a href="/customerservices">
                      <img
                        className="w-7 h-7"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAAOVBMVEUAAAD///////////////////////////////////////////////////////////////////////8KOjVvAAAAEnRSTlMA34CfIL9gEO9wQKCvj1CQzzC1fPmtAAADOElEQVRo3u2Z3XLjIAyFLf4hGNu8/8NuFwcEiQGbZnZ2Wn9XaQd0KumgGHe6ubn5RUinKQfwX6iVU2LYJ4ObGfwbQN1nwhuqfAVFzbfDC+6bgPhWeAd5LEtJgPL1MxKMp1pwbWTZFo2prYMN17H2XMjD3mP5yIh14m66NXJ8PBfZy0kwONjJNieEMexAAthQfDDZWVjRrnw2aGNAhavxFxmDzKp+BuSCCtfi6xi+cha4iHa4qCD3kWOSWStgh5wKdpUnBeYQf0Oz7vBFbOwL45anJhp0C6vmk9Mh7HSlWbmWx2fAsnzT+QaQwqwcTVMzqA5py7MFoqVZ65MKFfjJI81wD5q1Rm5Qps6lQJNBJZq1ivZoH3IqBfn37wCslRc9R6B94EwKIgUV/fgvy0gn4dQqJTMztUH7xOx5p0LJQjR+6mJTkYJx2zUy8biw3nQhQGXWNs/iblPdksooYwKivdDmRVpi/ku3BWtKoJ1pSLW0z4qyFcIKNFNz3oagmIJ+NgGaAqGzcs8EOuMk/rVoHxl+3zZRgLu2hYSP6GxkuOeAbThjA5/h2vPWhiLt0Vy+D7bqRuVzoEZYxqddAQLFRlVTAH8eYKHyx4CsV1YRY6zvI7AwCHdGQH0g8dShvgLF3iI21Lk+kFTauIUhT+uQeADok/C4vU1xIKlDgWx6VtLsjJjiY19A3AK3wC1wC/wGAfJvBdxMC2YxJrDg08tSvrh4Y5WvVx2JH6vf+SDTk5otrj0HzK9ftySFWet1tCxd3MvkSl6vlOm2JS1+ZVceiyA+jbDyYqggQx0sCGuaD3f6pcg8sr7ZVqQw+CNC6mar0BPgnfi4D4YEWL4O3NTCEAqXBWgKTomZujxSpy3dsW0BFgzO0T1nBEjudOYPYXkC4qKAVPmNUR2eg1weposCu2dBNuy15NcRcVXgaT2Ls+aVR34Ph+m6ACvekhlNCrQp3r+xAYFJn3lrPMchdFUA62JZ9/0zmQYEwqfO+1ADsRsjAqjg6aGEnLHbYwLoT3iXkEThaBsVKP+JkGkwzeNp09OQgCKRh08An8kXswX8HU0L4YLAGP+PABkXWE4JyOEUOJtubm5+JH8AbPaZ16QDZ/oAAAAASUVORK5CYII="
                        alt="logo not found"
                      />
                    </a>
                    <img
                      className="w-7 h-7"
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMA4CLvoGETgUKR0MAycVKwocrDEccAAAOUSURBVGje7VlbgqsgDBXCG8HL/jd7S8sYKUaEmfmanr+K5oS8ocsHH3zwh6BMEBtjKTFZPTfi8Qy85N+SbqxLO+C4wPbHelo615COYLikq+d8TnmfaoCs5SPc98QzESKvlOQpwxq1rJJNWUnZL62FVO2yyCtredXlH2pMfiy29+H8w7wmd2Xyy2ZGfZ+/IgmQ+h/S3QJnL8eh+A7BNkawPuXDpdsqv3I2ZKL1aX62Lh2C2slsUL7oBEV6QpiH+mEsTFe49Xqq0N+AEVqhOSn5NIHjnbCBUikVyu8TsFQAWvXs8rLoQw3JUH6PYInCPaRjLl6A7WWXC7vcJRiBTukrONUMQR/cpd1Ov0LwNH8Gk7MEATrBxAXG3BABtgh/WUJLFXpAqwmCNXUq0pbNrwHtNGoiT2wBd8gC2knwYQJT1fDTJugOzgb9Pr1Azipr6Cjyl1WA7U1D6XoWQdJiPoog4OTUwhwXOUM7YY4gBW8I+r3ZZnnnSWEgvQFiRVD1ZqrSZCXjSVL4UgHBRv54GsvjcwJJx5FqI8AcK+CmauYMSgrpAkdVQNk+JmoR3f0DugBBJUUgCbITAunjcFEB67UNCa71RHhqb9yeDOgKCIIcXRsZROtZM8WksAcKSxBwcsDIKvGznWXzh6ZTxEECukNBAo3O3vhBUBrqdL0PIqtPYz9OgEkR5wk6vuEbJkU2EQwRMBRElyisgNkrnnAyDBHYqj5ygUkhAzEiuvOGjJpWMPX5DpOCLGl5ZyNFhL3nZrgaC0LZ8EARkammvh4LBFnsDJmCrh3oJSbFycvmsuG04FCrqzSvZuVrKQhPnkRlsUjMhS9aSExSs3LEIKKbPn3qRwhiVhboYzIe6YM5wnFiVr68UgAyANrBq2B9c7a8PG7q69HVWJ9HR2crDetZ2VNmxhJvliHUSbE2XWto+u5YD8KTbVtomPEtNLOyXJcL+Jm7t3ZWpmEwIn7pAGnxjmYMzViAaOd7ppYp4KxMoow7/6ZsxKtZmYSddIMujbrrbMUmGIru/paz+QyDLmmAszLMXqnR8mE9qsiWHoNVtxNZFPk7AgN541qTD1yyovyBb+6ZSeMl63htYbGbXC7hbmcvx/t/MFg1X72Sk5QOoYiHuHyreiUQUTXSpYA0qz5SeBwjRDDrK5F4DKLsDm04C7MlCq34WUOxRAA0FTvzf9QhnDU//Fej9e6VUmwTwajlgw8++Dv4D6GoX9/0IE0uAAAAAElFTkSuQmCC"
                      alt="logo not found"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="flex-1 h-full overflow-auto mt-0 hide-scrollbar pb-pb-0">
              <div
                className="h-full w-full overflow-y-scroll flex flex-col items-center hide-scrollbar"
                style={{
                  background:
                    "linear-gradient(rgb(139, 128, 0), rgb(184, 134, 11), rgb(218, 165, 32), rgb(218, 165, 32), rgb(218, 165, 32), rgb(184, 134, 11), rgb(139, 128, 0))",
                }}
              >
                <div className="w-full">
                  <div className="">
                    <div className="h-10 w-full bg-[#B8860B] flex items-center justify-between px-2">
                      <div className="flex items-start justify-start">
                        <div className="h-7 w-36 bg-[#8B8000] rounded-xl flex items-center justify-between pr-4 border-black border-[0.5px] mr-1">
                          {/* <a href="/">
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth={0}
                              viewBox="0 0 24 24"
                              className="font-extrabold text-4xl text-white"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path fill="none" d="M0 0h24v24H0V0z" />
                              <path d="M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"></path>
                            </svg>
                          </a> */}
                          <p className="text-white font-serif font-semibold text-9 text-center w-100">
                            Spin To Wheel
                          </p>
                        </div>
                        <div className="h-7 w-7 bg-gradient-to-l from-[#F48711] to-[#F79816] rounded-[100%] flex items-center justify-between pr-4 border-black border-[0.5px]">
                          <div>
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth={0}
                              viewBox="0 0 256 256"
                              className="font-extrabold text-[20px] text-black flex items-center justify-center pl-1"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M144,180a16,16,0,1,1-16-16A16,16,0,0,1,144,180Zm92-52A108,108,0,1,1,128,20,108.12,108.12,0,0,1,236,128Zm-24,0a84,84,0,1,0-84,84A84.09,84.09,0,0,0,212,128ZM128,64c-24.26,0-44,17.94-44,40v4a12,12,0,0,0,24,0v-4c0-8.82,9-16,20-16s20,7.18,20,16-9,16-20,16a12,12,0,0,0-12,12v8a12,12,0,0,0,23.73,2.56C158.31,137.88,172,122.37,172,104,172,81.94,152.26,64,128,64Z"></path>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-start justify-start">
                        <div style={{ lineHeight: "24px" }}>
                          ₹{walletBalance}
                        </div>
                        <div className="h-7 w-7 bg-gradient-to-l bg-[#8B8000] rounded-[100%] flex items-center justify-between pr-4 border-black border-[0.5px] ml-1">
                          <button onClick={betHistoryBtn}>
                            <svg
                              stroke="currentColor"
                              fill="currentColor"
                              strokeWidth={0}
                              viewBox="0 0 512 512"
                              className="font-extrabold text-[20px] text-white flex items-center justify-center pl-1"
                              height="1em"
                              width="1em"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M32 96v64h448V96H32zm0 128v64h448v-64H32zm0 128v64h448v-64H32z"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      className="fixed inset-0 z-50 flex justify-center bg-black bg-opacity-50"
                      style={{
                        display: isBetHistoryModalOpen ? "flex" : "none",
                      }}
                    >
                      <div className="text-white absolute p-2 top-10 border-gray border-[1px] bg-blackAviator4 shadow-lg">
                        <div className="flex items-center justify-between text-xsm">
                          <h1>Game history</h1>
                          <svg
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth={0}
                            version="1.1"
                            viewBox="0 0 16 16"
                            className="text-blackLight hover:text-white"
                            height={20}
                            width={20}
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={betHistoryBtn}
                          >
                            <path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" />
                            <path d="M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z" />
                          </svg>
                        </div>
                        <div className="overflow-x-auto hide-scrollbar mt-2 mb-2">
                          <table className="w-full min-w-max">
                            <thead>
                              <tr className="text-[12px] border-gray border-y">
                                <th className="py-2 px-1">S.no.</th>
                                <th className="py-2 px-1">Period no</th>
                                <th className="py-2 px-1">Selected</th>
                                <th className="py-2 px-1">Result</th>
                                <th className="py-2 px-1">Amount</th>
                                <th className="py-2 px-1">Win Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {userBetHistory.length > 0 ? (
                                userBetHistory.map((item, index) => (
                                  <tr key={index} className="text-[12px]">
                                    <td className="py-1 text-center">
                                      {index + 1}
                                    </td>
                                    <td className="py-1 text-center">
                                      {item.period}
                                    </td>
                                    <td className="py-1 text-center">
                                      {item.selected_data &&
                                        JSON.parse(item.selected_data).map(
                                          (data, index) => (
                                            <div key={index}>
                                              {Object.keys(data).join(", ")}
                                            </div>
                                          ),
                                        )}
                                    </td>
                                    <td className="py-1 text-center">
                                      {item.result},{" "}
                                      {item.result % 2 ? "odd" : "even"}
                                    </td>
                                    <td className="py-1 text-center">
                                      {item.totalBetAmount}
                                    </td>
                                    <td
                                      className={
                                        item.winAmount > 0
                                          ? "py-1 text-center text-green"
                                          : "py-1 text-center text-redAviator"
                                      }
                                    >
                                      {item.winAmount}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    className="py-2 text-center text-gray-500"
                                    colSpan={6}
                                  >
                                    Bet not available!
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div
                      className="fixed inset-0 z-50 flex justify-center bg-black bg-opacity-50"
                      style={{
                        display: isResultModalOpen ? "flex" : "none",
                      }}
                    >
                      <div
                        className="text-white absolute p-2 w-[310px] rounded-lg"
                        style={{
                          top: "32%",
                          height: "260px",
                          background:
                            "url(/spinwheel/images/result_bg.png) no-repeat center center",
                          backgroundSize: "cover",
                          filter: "hue-rotate(-155deg)",
                          width: "185px",
                        }}
                      >
                        <div className="flex items-center justify-between text-xsm">
                          <h1
                            style={{
                              position: "absolute",
                              top: "75px",
                              left: "15%",
                              fontSize: "18px",
                              width: "130px",
                              textAlign: "center",
                            }}
                          >
                            Result
                          </h1>
                          <svg
                            style={{
                              position: "absolute",
                              bottom: "-35px",
                              left: "46%",
                              color: "#fff",
                            }}
                            stroke="currentColor"
                            fill="currentColor"
                            strokeWidth={0}
                            version="1.1"
                            viewBox="0 0 16 16"
                            className="text-blackLight hover:text-white"
                            height={25}
                            width={25}
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={betResultBtn}
                          >
                            <path d="M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z" />
                            <path d="M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z" />
                          </svg>
                        </div>
                        <div className="overflow-x-auto hide-scrollbar mt-2 mb-2">
                          <div className="w-full min-w-max">
                            <h1
                              style={{
                                position: "absolute",
                                top: "105px",
                                left: "15%",
                                fontSize: "18px",
                                textAlign: "center",
                                width: "130px",
                              }}
                            >
                              {result} - {result % 2 ? "Odd" : "Even"}
                            </h1>

                            <div
                              style={{
                                position: "absolute",
                                bottom: "55px",
                                left: "15%",
                                color: "#00bc8c",
                                fontSize: "18px",
                                fontWeight: 900,
                                width: "130px",
                                textAlign: "center",
                              }}
                            >
                              <h1 style={{ color: "#fff" }}>
                                {lastWinAmount > 0 ? "Win" : "Lose"}{" "}
                              </h1>
                              <h1
                                style={{ marginTop: "25px", fontSize: "25px" }}
                              >
                                {lastWinAmount > 0
                                  ? lastWinAmount
                                  : lastBetAmount}
                              </h1>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-between my-2">
                    <div
                      className="h-8 w-24 bg-[#8B8000] opacity-90 rounded-lg text-center text-9 font-roboto"
                      style={{ textShadow: "black 1px 1px 3px" }}
                    >
                      <b>S.no :-</b>{" "}
                      <p className="font-bold text-9">{gameId}</p>
                    </div>
                    <div
                      className="h-8 w-24 bg-[#8B8000] opacity-90 rounded-lg text-center text-[20px] font-bold font-mono"
                      style={{ textShadow: "black 1px 1px 3px" }}
                    >
                      {timmer}
                    </div>
                  </div>
                  <div className="flex items-center justify-center px-3">
                    <div
                      className="h-8 w-full bg-[#8B8000] overflow-scroll hide-scrollbar opacity-90 flex items-center justify-center text-[20px] font-bold font-mono gap-2"
                      style={{ textShadow: "black 1px 1px 3px" }}
                    >
                      {resultDetails.map((item, index) => (
                        <p
                          key={index}
                          className="bg-yellow rounded-md px-2 w-full text-center"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          {item.result}
                        </p>
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-5 xs1:mt-0 w-full">
                    <div className="flex flex-col items-center -mt-5 xs1:mt-[5px]">
                      <img
                        className="w-10 h-10"
                        src="/spinwheel/images/sp_show-J8fSBKRJ.png"
                        alt="sd"
                      />
                      <div
                        className="relative w-[250px] h-[250px] xs1:w-[320px] xs1:h-[320px] rounded-full overflow-hidden"
                        style={{
                          backgroundImage:
                            'url("/spinwheel/images/s_first_wheel-CIU2gIkf.png")',
                          backgroundSize: "cover",
                          backgroundPosition: "center center",
                          backgroundRepeat: "no-repeat",
                        }}
                      >
                        <div
                          className="absolute inset-0 xs1:mx-4 m-[10px] xs1:my-4 rounded-full spinwheel"
                          style={{
                            transition:
                              "transform 6s cubic-bezier(0.1, 0.7, 0.1, 1)",
                            transform: `rotate(${rotation}deg)`,
                          }}
                        >
                          <div
                            className="absolute inset-0 rounded-full"
                            style={{
                              transform: "rotate(-17deg)",
                              background:
                                "conic-gradient(rgb(255, 99, 71) 0%, rgb(255, 99, 71) 10%, rgb(252, 124, 118) 10%, rgb(252, 124, 118) 20%, rgb(30, 144, 255) 20%, rgb(30, 144, 255) 30%, rgb(255, 215, 0) 30%, rgb(255, 215, 0) 40%, rgb(186, 85, 211) 40%, rgb(186, 85, 211) 50%, rgb(32, 178, 170) 50%, rgb(32, 178, 170) 60%, rgb(255, 140, 0) 60%, rgb(255, 140, 0) 70%, rgb(139, 0, 0) 70%, rgb(139, 0, 0) 80%, rgb(255, 20, 147) 80%, rgb(255, 20, 147) 90%, rgb(173, 255, 47) 90%, rgb(173, 255, 47) 100%)",
                            }}
                          ></div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform: "rotate(5deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(-5deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              0
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform: "rotate(38deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(4deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              1
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform: "rotate(75deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(358deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              2
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform:
                                "rotate(111deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(5deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              3
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform:
                                "rotate(147deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(355deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              4
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform:
                                "rotate(186deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(352deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              5
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform:
                                "rotate(222deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(3deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              6
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform:
                                "rotate(256deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(350deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              7
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform:
                                "rotate(292deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(3deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              8
                            </div>
                          </div>
                          <div
                            className="absolute top-1/2 left-[50%] -mt-4 -ml-1.5"
                            style={{
                              transform:
                                "rotate(328deg) translate(-50%, -90px)",
                              transformOrigin: "center center",
                            }}
                          >
                            <div
                              className=" font-bold text-black"
                              style={{
                                transform: "rotate(13deg)",
                                fontSize: 20,
                                textShadow: "white 1px 1px 2px",
                                textAlign: "center",
                              }}
                            >
                              9
                            </div>
                          </div>
                          <img
                            src="/spinwheel/images/s_third_wheel-DArhutHA.png"
                            alt="center"
                            className="absolute top-1/2 left-1/2 translate-x-[-50%] translate-y-[-50%] w-[60px] h-[60px] z-10"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-5 gap-2 mx-4 my-2 xs1:my-4">
                    <div
                      onClick={zeroNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      0
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {zeroBetCount}
                      </div>
                    </div>
                    <div
                      onClick={oneNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      1
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {oneBetCount}
                      </div>
                    </div>
                    <div
                      onClick={twoNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      2
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {twoBetCount}
                      </div>
                    </div>
                    <div
                      onClick={threeNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      3
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {threeBetCount}
                      </div>
                    </div>
                    <div
                      onClick={fourNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      4
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {fourBetCount}
                      </div>
                    </div>
                    <div
                      onClick={fiveNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      5
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {fiveBetCount}
                      </div>
                    </div>
                    <div
                      onClick={sixNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      6
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {sixBetCount}
                      </div>
                    </div>
                    <div
                      onClick={sevenNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      7
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {sevenBetCount}
                      </div>
                    </div>
                    <div
                      onClick={eightNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      8
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {eightBetCount}
                      </div>
                    </div>
                    <div
                      onClick={nineNumberBet}
                      className="relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] rounded-lg text-center text-white font-bold text-lg shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px", width: "62px" }}
                    >
                      9
                      <div className="text-sm font-normal border-t-[1px] border-t-gradient-to-tr from-[#00308F] to-[#4169E1]">
                        {nineBetCount}
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 mx-4 mb-0">
                    <div
                      className="relative bg-gradient-to-tr from-[#800020] to-[#B22222] w-full flex items-center text-center text-white font-bold text-lg py-0.5 xs1:py-1.5 shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px" }}
                      onClick={oddBet}
                    >
                      <div className="flex justify-between mr-2 ml-2 w-full">
                        <div>Odd</div>
                        <div className="text-sm font-normal">{oddBetCount}</div>
                      </div>
                    </div>
                    <div
                      className="relative bg-gradient-to-tr from-[#00308F] to-[#4169E1] w-full flex items-center text-center text-white font-bold text-lg py-0.5 xs1:py-1.5 shadow-md cursor-pointer"
                      style={{ textShadow: "black 1px 1px 2px" }}
                      onClick={evenBet}
                    >
                      <div className="flex justify-between w-full mr-2 ml-2">
                        <div>Even</div>
                        <div className="text-sm font-normal">
                          {evenBetCount}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mx-4 my-4 xs1:my-4 mb-0 xs1:mb-0">
                    <button
                      className="w-full bg-yellow rounded-lg text-white font-bold py-0.5 xs1:py-1 shadow-md"
                      style={{ textShadow: "black 1px 1px 2px" }}
                      onClick={clearAllBets}
                    >
                      Clear All
                    </button>
                  </div>
                </div>
                <div className="w-full mt-0 xs1:mt-0">
                  <div className="relative -mt-2 xs1:mt-0">
                    <div className="flex items-center justify-center p-2 mt-0 xsm:mt-2">
                      <div className="sm:h-36 w-full rounded-lg bg-yellow px-4 pt-1 xs1:py-2 xsm:p-4">
                        <div className="h-12 xs1:h-14 w-full rounded-3xl bg-[#569123] border-[0.5px] border-black">
                          <div className="flex justify-between items-center">
                            <div className="pl-4">
                              <div className="text-white pl-12 font-serif text-[12px]">
                                BET
                              </div>
                              <div className="relative flex items-center h-6 w-32 bg-[#08565A] rounded-3xl border-black border-[0.5px]">
                                <span className="text-white text-xs pl-10 pr-1">
                                  ₹
                                </span>
                                <input
                                  inputMode="numeric"
                                  placeholder="Enter amount"
                                  type="text"
                                  className="pl-0 pr-2 bg-transparent flex-1 text-white text-xs text-left outline-none placeholder:text-[10px] no-spinner"
                                  value={betAmount}
                                  onChange={handleBetChange}
                                  max={maxBetAmount}
                                  min={minBetAmount}
                                />
                              </div>
                            </div>
                            <div className="flex pr-6 space-x-3">
                              <div className="h-7 w-7 bg-[#8B8000] rounded-full flex items-center justify-center border-black border-[0.5px]">
                                <button onClick={minusBet}>
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    version="1.2"
                                    baseProfile="tiny"
                                    viewBox="0 0 24 24"
                                    className="text-[20px] text-white"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M18 11h-12c-1.104 0-2 .896-2 2s.896 2 2 2h12c1.104 0 2-.896 2-2s-.896-2-2-2z"></path>
                                  </svg>
                                </button>
                              </div>
                              <div className="h-7 w-7 bg-[#8B8000] rounded-full flex items-center justify-center border-black border-[0.5px]">
                                <button onClick={betOptions}>
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 16 16"
                                    className="text-[20px] text-white"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M4.318 2.687C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4c0-.374.356-.875 1.318-1.313M13 5.698V7c0 .374-.356.875-1.318 1.313C10.766 8.729 9.464 9 8 9s-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777A5 5 0 0 0 13 5.698M14 4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16s3.022-.289 4.096-.777C13.125 14.755 14 14.007 14 13zm-1 4.698V10c0 .374-.356.875-1.318 1.313C10.766 11.729 9.464 12 8 12s-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10s3.022-.289 4.096-.777A5 5 0 0 0 13 8.698m0 3V13c0 .374-.356.875-1.318 1.313C10.766 14.729 9.464 15 8 15s-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13s3.022-.289 4.096-.777c.324-.147.633-.323.904-.525"></path>
                                  </svg>
                                </button>
                              </div>
                              <div className="h-7 w-7 bg-[#8B8000] rounded-full flex items-center justify-center border-black border-[0.5px]">
                                <button onClick={plusBet}>
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth={0}
                                    viewBox="0 0 512 512"
                                    className="text-[20px] text-white"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M416 277.333H277.333V416h-42.666V277.333H96v-42.666h138.667V96h42.666v138.667H416v42.666z"></path>
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between mt-3">
                          <button
                            className={`relative bg-gradient-to-tr from-[#448B02] to-[#5FAF09] text-white shadow-lg drop-shadow-[0_4px_3px_rgba(0,0,0,0.3)] h-8 xs1:h-12 w-full font-serif font-bold text-[14px] m-1 xs1:m-3 rounded-2xl flex items-center justify-center ${
                              spinnerRolling
                                ? "opacity-50 cursor-not-allowed"
                                : ""
                            }`}
                            onClick={betNow}
                            disabled={spinnerRolling}
                          >
                            BET
                          </button>
                        </div>

                        <div
                          className="absolute -top-32 right-12 bg-[#569123] z-50 shadow-lg border-radius-5 p-2 w-72 grid grid-cols-3 gap-2 border-black border-[0.5px]"
                          style={{ display: isBetModalOpen ? "grid" : "none" }}
                        >
                          <div
                            className="p-2 text-center bg-[#2b7009] border-black border-[0.5px] text-white border-radius-5 hover:bg-gray-600 cursor-pointer"
                            onClick={() => {
                              playSound(audioFiles.click);
                              setBetAmount(10);
                            }}
                          >
                            10
                          </div>
                          <div
                            className="p-2 text-center bg-[#2b7009] border-black border-[0.5px] text-white border-radius-5 hover:bg-gray-600 cursor-pointer"
                            onClick={() => {
                              playSound(audioFiles.click);
                              setBetAmount(20);
                            }}
                          >
                            20
                          </div>
                          <div
                            className="p-2 text-center bg-[#2b7009] border-black border-[0.5px] text-white border-radius-5 hover:bg-gray-600 cursor-pointer"
                            onClick={() => {
                              playSound(audioFiles.click);
                              setBetAmount(50);
                            }}
                          >
                            50
                          </div>
                          <div
                            className="p-2 text-center bg-[#2b7009] border-black border-[0.5px] text-white border-radius-5 hover:bg-gray-600 cursor-pointer"
                            onClick={() => {
                              playSound(audioFiles.click);
                              setBetAmount(100);
                            }}
                          >
                            100
                          </div>
                          <div
                            className="p-2 text-center bg-[#2b7009] border-black border-[0.5px] text-white border-radius-5 hover:bg-gray-600 cursor-pointer"
                            onClick={() => {
                              playSound(audioFiles.click);
                              setBetAmount(200);
                            }}
                          >
                            200
                          </div>
                          <div
                            className="p-2 text-center bg-[#2b7009] border-black border-[0.5px] text-white border-radius-5 hover:bg-gray-600 cursor-pointer"
                            onClick={() => {
                              playSound(audioFiles.click);
                              setBetAmount(500);
                            }}
                          >
                            500
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 bg-[#9195A3]" />
        </div>
      </div>
    </>
  );
};

export default SpinWheel;
